import { addToDate, toTimestamp } from '@/common/utils/date';

//Funcion para validar si puede borrar un archivo el vendedor
export const validaTiempo = (path, udt) => {
  if (!path) return true;
  if (!udt) return true;
  const limitDate = addToDate(udt, 24, 'hours');
  return toTimestamp(limitDate) > new Date().getTime();
}